export var isOpen = function (menuPath, currentPath, item) {
    return ((menuPath &&
        (((item === null || item === void 0 ? void 0 : item.exact) && currentPath.toLowerCase() === menuPath.toLowerCase()) ||
            (!(item === null || item === void 0 ? void 0 : item.exact) && currentPath.toLowerCase().startsWith(menuPath.toLowerCase())))) ||
        false);
};
